import { render, staticRenderFns } from "./SideBySideComparisonModal.vue?vue&type=template&id=dd7e5c48"
import script from "./SideBySideComparisonModal.vue?vue&type=script&lang=js"
export * from "./SideBySideComparisonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports